import React from 'react'
import "./Community.css"

const Community = () => {
  return (
    <div id='community'>

<div className='community_page'>

    <h1>
    Join Our Community
    </h1>

<div className='social_icon'>
<i class="fa-brands fa-facebook fa-2x " ></i>
<a target='_blank' href="">

<span>Facebook</span>

</a>
<i class="fa-brands fa-twitter fa-2x  "></i>
<a target='_blank'  href="">
<span>Twitter</span>

</a>
<i class="fa-brands fa-discord fa-2x "></i>
<a target='_blank'  href="">

<span>Discord</span>

</a>
<i class="fa-brands fa-telegram fa-2x "></i>
<a target='_blank' href="">
<span>Telegram</span>
</a>
<i class="fa-brands fa-medium fa-2x "></i>
<a target='_blank' href="">
<span>Medium</span>

</a>
</div>

</div>

    </div>
  )
}

export default Community